import { getAllSwappableItemsForProduct, swapProductInSubscription } from '../subscription-modal/ordergroove-api-helper';

export default function accountSwapProduct() {
    return {
        showProductSwap: true,
        swapableProducts: [],
        selectedSwapProduct: null,
        currentItem: {},
        processingSwap: false,
        swappableItemsLoading: false,
        title: 'Swap Products',
        currencyCode: "USD",

        init() {
            this.$watch('selectedSwapProduct', (newValue) => {
                if (newValue) {
                    this.title = `${newValue.name}`;
                } else {
                    this.title = 'Swap Products';
                }
            });

            window.addEventListener('selected-item-to-swap', (event) => {
                this.handleSelectedItem(event.detail.item);
            });
        },

        resetModal() {
            this.title = 'Swap Products';
            this.swappableItemsLoading = false;
            if (!this.processingSwap) {
                this.selectedSwapProduct = null;
            }
        },

        async handleSelectedItem(item) {
            this.currentItem = item;
            let swappableItems = item.product?.swappableItems || item.productObj?.swappableItems || [];
            
            // Check if swappable items are still loading (empty array but product has swap group)
            const productObj = item.product || item.productObj;
            const hasSwapGroup = productObj?.groups?.some(g => g.group_type === 'sku_swap');
            const swapGroup = productObj?.groups?.find(g => g.group_type === 'sku_swap');
            
            if (swappableItems.length === 0 && hasSwapGroup) {
                this.swappableItemsLoading = true;

                window.dsc = window.dsc || {};
                window.dsc.swappableItemsByGroup = window.dsc.swappableItemsByGroup || {};
                const rawGroupName = swapGroup?.name;
                const groupName = typeof rawGroupName === 'string' ? rawGroupName.trim() : rawGroupName;

                if (groupName) {
                    const cachedSwappableItems = window.dsc?.swappableItemsByGroup?.[groupName];

                    if (cachedSwappableItems) {
                        swappableItems = cachedSwappableItems;
                    } else {
                        try {
                            swappableItems = (await getAllSwappableItemsForProduct(groupName)) || [];
                        } catch (error) {
                            swappableItems = [];
                        }
                    }
                }
            }

            this.swappableItemsLoading = false;
            this.swapableProducts = swappableItems;
            const currentProd = this.currentItem?.product?.external_product_id || this.currentItem?.productObj?.external_product_id;
            if (currentProd) {
                this.swapableProducts = this.swapableProducts.filter(
                    p => p.external_product_id !== currentProd
                );
            }
            this.showProductSwap = this.swapableProducts.length > 0;
        },
        async swapProduct() {
            this.processingSwap = true;
            const response = await swapProductInSubscription(this.currentItem.subscription || this.currentItem.public_id, this.selectedSwapProduct.external_product_id);
            if (response.success) {
                this.$dispatch('update-swapped-product', { subscriptionId: this.currentItem.subscription || this.currentItem.public_id, newProduct: this.selectedSwapProduct });
                this.$dispatch('toast', { 
                    message: window.translations?.customer?.global?.product_swapped, 
                    type: 'success', 
                    product: this.selectedSwapProduct
                });
                //TODO: add swap datalayer information for non cancel flow?
                this.swapableProducts = [];
                this.selectedSwapProduct = null;
                this.processingSwap = false;
                this.closeModal('account-swap-product-modal');
            }
        }
    }
}